let language = {
    "3000601": "{{site}} not support currency: {{currencyCode}}",
    "3000697": "The store currency({{storeCurrencyCode}}) is inconsistent with the store product pricing currency({{currencyCode}})"
}

export { language }